import { makeStyles } from '@material-ui/core';

export default makeStyles({
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
  listItem: {
    margin: 0,
    padding: 0,
  },
});
